import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { FunctionsService } from '../../../services/functions.service';
import { NgbModalOptions, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AgmMap } from '@agm/core';
import { ExportAlertLogComponent } from '../export-alert-log/export-alert-log.component';
import { DomSanitizer } from '@angular/platform-browser';
import { PaginationModel } from 'src/app/models/paginationModel';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-alert-history-log-component',
  templateUrl: './alert-history-log.component.html',
  styleUrls: ['./alert-history-log.component.css'],
  providers: [NgxSpinnerService]
})
export class AlertHistoryLogComponent implements OnInit {
  modalOptions: NgbModalOptions = {};
  alertId:any;
  alertStatus = 1;
  totalLength = 0;
  pageIndex = 0; 
  pageSize = 5;
  chatMessages: Array<any> = [];
  logs:any;
  isClosed:boolean=true;
  filter: string = "";
  notesEmpty: boolean;
  language = localStorage.getItem('language')?localStorage.getItem('language'):'en';
  @ViewChild('AgmMap', {static: true}) agmMap: AgmMap;
  @ViewChild('paginator') paginator: MatPaginator;
  constructor(
    private activatedRoute:ActivatedRoute,
    private apiService: ApiService,
    public functionsService: FunctionsService,
    private spinner:NgxSpinnerService,
    private modalService: NgbModal,
    public pagination: PaginationModel,
    private translate: TranslateService,
    private router: Router
    ) { 
      this.activatedRoute.params.subscribe(params => {
        this.pagination.AlertId = params['alertId'];
      });
      this.logs = [];
    }

  ngOnInit() {
    this.functionsService.setTitle('alert.activity');
    if(localStorage.getItem('language') != null){
      this.functionsService.useLanguageRed(this.language);
    }
    this.pagination.ChatHistory = false;
    this.fetchAlertLogs(); 
  }

  fetchAlertLogs(){
    this.spinner.show();
    this.logs = [];
    this.pagination.Filter = this.filter;
    this.pagination.Page = this.pageIndex;
    this.pagination.PageSize = this.pageSize;
    this.apiService.getAlertLogs(this.pagination).subscribe(
      data => {
        if(data["alert"]["status"]!=1 || data["alert"]["organizationId"]!=this.functionsService.getOrg()){this.isClosed = false;}
        this.totalLength = data["totalLength"];
                if(document.getElementsByClassName("mat-paginator-page-size-label")[0]){
                    document.getElementsByClassName("mat-paginator-page-size-label")[0].innerHTML = this.translate.instant("paginator.items_per_page");
                    this.translate.onLangChange.subscribe(() => {
                        document.getElementsByClassName("mat-paginator-page-size-label")[0].innerHTML = this.translate.instant("paginator.items_per_page");
                  });
                }
          let jsonString = JSON.stringify(data);
          let jsonObject = JSON.parse(jsonString);
          var i = 0;
          var k = 0;
          while((i<jsonObject["alertLog"].length)){
            if(jsonObject["alertLog"][i]){
              var newDate = new Date(jsonObject["alertLog"][i].eventDate+"Z");
              if(newDate.getTime()){
                this.logs[k] = [];
                if(jsonObject["alertLog"][i].name == null){
                  this.logs[k][0] = null;
                  var params = (jsonObject["alertLog"][i].description.split(","));
                  this.logs[k][1] = {name: params[0], pastAlertType: params[1], newAlertType: params[2]};
                }
                else if(jsonObject["alertLog"][i].name == "attend_timer" || jsonObject["alertLog"][i].name == "close_timer"){
                  this.logs[k][0] = jsonObject["alertLog"][i].name;
                  var params = (jsonObject["alertLog"][i].description.split("."))
                  this.logs[k][1] = {days: params[0], time: params[1]};
                }
                else{
                this.logs[k][0] = jsonObject["alertLog"][i].name;
                this.logs[k][1] = jsonObject["alertLog"][i].description;
                }
                this.logs[k][2] = this.functionsService.convertUTCDateToLocalDate(jsonObject["alertLog"][i].eventDate);
                i++;
              }
              k++;
            }
            else if(jsonObject["alertLog"][i]){
              this.logs[k] = [];
              if(jsonObject["alertLog"][i]['name'] == null){
                this.logs[k][0] = null;
                var params = (jsonObject["alertLog"][i].description.split(","));
                this.logs[k][1] = {name: params[0], pastAlertType: params[1], newAlertType: params[2]};
              }
              else if(jsonObject["alertLog"][i].name == "attend_timer" || jsonObject["alertLog"][i].name == "close_timer"){
                this.logs[k][0] = jsonObject["alertLog"][i].name;
                var params = (jsonObject["alertLog"][i].description.split("."))
                this.logs[k][1] = {days: params[0], time: params[1]};
              }
              else{
              this.logs[k][0] = jsonObject["alertLog"][i].name;
              this.logs[k][1] = jsonObject["alertLog"][i].description;
              }
              this.logs[k][2] = this.functionsService.convertUTCDateToLocalDate(jsonObject["alertLog"][i].eventDate);
              i++;
              k++;
            }
          }
          if(this.logs.length == 0 && this.filter == "notes"){
            this.logs[0] = [];
            this.logs[0][0] = "notes_empty";
            this.logs[0][1] = "";
          }
          this.notesEmpty = this.logs[0][0]=="notes_empty"? true: false;
          this.spinner.hide();
        });
      error => {
        this.spinner.hide();
        this.functionsService.errorHandler(error["status"]);
      };
  }

  refreshLogs(){
    if(this.filter == "notes"){
      this.paginator.pageIndex = 0;
      this.paginator._changePageSize(5);
    }
    this.fetchAlertLogs();
  }

  nextPage(evt){
    this.pageIndex = evt.pageIndex;
    this.pageSize = evt.pageSize;
    this.fetchAlertLogs();
  }

  openExportLog(){
    const modalRef = this.modalService.open(ExportAlertLogComponent, { size: 'md' });
    modalRef.componentInstance.alertId = this.pagination.AlertId;
  }

  chatLog(){
    this.router.navigateByUrl('/main/alertHistory/activity/'+ this.pagination.AlertId + '/chat');
  }

  applyFilter(checked){
    this.filter = checked? "notes" : "";
    this.paginator.pageIndex = 0;
    this.paginator._changePageSize(5);
    this.fetchAlertLogs();
  }
}


